module.exports = __webpack_public_path__ + "screenshots.jpg?7eb8424718eae6091680747c29a198e5";


//////////////////
// WEBPACK FOOTER
// ./static/screenshots.jpg
// module id = 359
// module chunks = 0